export { AnimatedShipIndicator } from '../../compositions/shared/AnimatedShipIndicator';
